import React, { Component } from 'react'
import { Provider } from 'react-redux'
import store from 'store'
import Header from 'components/Header/Header'
import MediaEditorContainer from 'containers/MediaEditorContainer/MediaEditorContainer'
import './App.sass'
import 'semantic-ui-css/semantic.min.css'

class App extends Component {
  render () {
    return (
      <Provider store={store}>
        <div>
          <Header />
          <MediaEditorContainer />
        </div>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/startup/App.js